import params_and_translation_config from "./params_and_translation_config";

let config = {
    backend_url: process.env.VUE_APP_BACKEND_URL,
    cabinet_url: process.env.VUE_APP_CABINET_URL,
    cabinet_auth_url: process.env.VUE_APP_CABINET_AUTH_URL,
    website_redirect_url: process.env.VUE_APP_WEBSITE_REDIRECT_URL,
};

Object.assign(config, params_and_translation_config);

export default config;